import { render, staticRenderFns } from "./ReleaseDetailModal.vue?vue&type=template&id=c08aae24&"
import script from "./ReleaseDetailModal.vue?vue&type=script&lang=js&"
export * from "./ReleaseDetailModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports